<div class="footer">
  <span class="footer-item">
    © HOLCIM {{ currentDate }} | {{ "AppVersion" | translate }}
    {{ appVersion }}
  </span>
  <span class="footer-item">
    <a routerLink="" class="pointer-cursor" (click)="onPrivacyPolicyClicked()">
      {{ "TermsAndConditions" | translate }}
    </a>
    |
    <a routerLink="" class="pointer-cursor" (click)="onCookiePolicyClicked()">
      {{ "CookiePolicy" | translate }}
    </a>
  </span>
</div>
